// Libraries
import React from 'react'
import PropTypes from 'prop-types'

// Component
export const IconGoogle = ({ width, height, onClick }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 59 59"
      onClick={onClick}
      style={{ cursor: 'pointer' }}
    >
      <circle className="a" fill="#7f40bd" cx="29.5" cy="29.5" r="29.5" />
      <path
        className="b"
        fill="#fff"
        d="M23.422,20.633h-9.34a.335.335,0,0,0-.333.367l.182,1.888a.335.335,0,0,0,.315.3L16.2,23.3l-3.746,5.2L8.366,20.357l2.949-.113a.335.335,0,0,0,.322-.33l.022-1.689a.335.335,0,0,0-.335-.339H.335A.335.335,0,0,0,0,18.221V20.1a.335.335,0,0,0,.33.335l3.1.045L9.34,30.9,9.313,37.4l-4.105.168a.335.335,0,0,0-.321.328l-.033,1.74a.335.335,0,0,0,.335.341H18.03a.335.335,0,0,0,.335-.352l-.09-1.723a.335.335,0,0,0-.317-.317l-3.532-.185-.514-6.337,6.341-7.64,2.582-.117a.335.335,0,0,0,.306-.238l.6-2a.335.335,0,0,0-.317-.443Z"
        transform="translate(17.918 0.674)"
      />
    </svg>
  )
}

IconGoogle.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  onClick: PropTypes.func,
}

IconGoogle.defaultProps = {
  width: '45px',
  height: '45px',
  onClick: () => {},
}

export default IconGoogle
